const menuOptions = [
  { key: "about", title: "About" },
  { key: "contact", title: "Contact" },
  { key: "help", title: "Help" },
];

export const getMenuOptions = () => menuOptions;
